
const initialState = {
  data: [],
  loading: false,
  success: false,
  error: false,
};

export const getResearcherByEmail = () => (state = initialState, action) => {
  switch (action.type) {
    case `RESEARCHER_BY_EMAIL_REQUEST_REQUEST`: {
      return { ...initialState, loading: true };
    }
    case `RESEARCHER_BY_EMAIL_REQUEST_SUCCESS`: {
      return { ...state, data: action.data, success: false, loading: false };
    }
    case `RESEARCHER_BY_EMAIL_REQUEST_FAILURE`: {
      return { ...state, data: [], success: false, error: action.error, loading: false };
    }
    default:
      return state;
  }
};
